import _ from 'lodash';
import { AfterViewInit, Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Subject } from 'rxjs';
import { RouteReuseStrategyService } from '../../services/route-reuse-strategy-service/route-reuse-strategy-service.service';
import { filter, takeUntil } from 'rxjs/operators';
import { UntypedFormGroup, Validators } from '@angular/forms';
import { UntypedFormControl } from '@angular/forms';
import { DonorService } from 'app/core/services/donor.service';
import { EmailNameSpliterService } from 'app/core/services/email-name-spliter.service';

@Component({
  selector: 'app-menu-offline-one-page',
  templateUrl: './menu-offline-one-page.component.html',
  styleUrls: ['./menu-offline-one-page.component.scss']
})
export class MenuOfflineOnePageComponent implements OnInit, AfterViewInit, OnDestroy {
  
  @ViewChild('offlineDonation', { static: true }) offlineOneRef: ElementRef;

  private takeUntilSubject: Subject<any> = new Subject();
  private takeUntilRouteReuseStrategySubject: Subject<any> = new Subject();
  
  public form: UntypedFormGroup = new UntypedFormGroup({
    email: new UntypedFormControl("", [Validators.required, Validators.pattern(/^([a-zA-Z0-9_\.\-\+])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/)]),
    name: new UntypedFormControl("",[Validators.required]),
  });

  private donorData = null;

  private allProfiles: any = null;
  public searchResult = [];

  constructor(
    private routeReuseStrategyService: RouteReuseStrategyService,
    private donorService: DonorService,
    private emailNameSpliter: EmailNameSpliterService,
  ) {}

  ngOnInit(): void {
    this.routeReuseStrategyService.status = true;
    this.routeReuseStrategyService.routeReuseStrategySubject.pipe(
      takeUntil(this.takeUntilRouteReuseStrategySubject)
    ).subscribe(() => {
      this.takeUntilSubject.next(null);
      this.takeUntilSubject.complete();
      this.takeUntilSubject = new Subject();

      this.ngAfterViewInit();
    });
  }

  ngAfterViewInit(): void {
    const userStyles = window['documentManager'].createElement('link');
    userStyles.href = 'paybee-spa/styles.css?v=398';
    userStyles.rel = 'stylesheet';
    window['$'](this.offlineOneRef.nativeElement).append(userStyles);

    window['orgMain'].showOfflineDonationOne();

    this.setSearchSubscription('email', 0);
    this.setSearchSubscription('name', 1);
  }

  ngOnDestroy(): void {
    window['$']('#offlineDonation').empty()
    window['$']('#offlineDonation').hide()

    this.takeUntilSubject.next(null);
    this.takeUntilSubject.complete();

    this.takeUntilRouteReuseStrategySubject.next(null);
    this.takeUntilRouteReuseStrategySubject.complete();

    this.routeReuseStrategyService.status = false;
  }

  private setSearchSubscription(controlName: string, type: number){
    this.form.get(controlName).valueChanges
    .pipe(
      filter(value => _.isString(value)),
      takeUntil(this.takeUntilSubject)
    ).subscribe((value) => {
      this.donorData = null;

      if (value.length > 2) {
        this.searchDonor(value, type);
      } else {
        this.searchResult = [];
      }
    });
  }

  private searchDonor(value: string, searchType: number = 0 | 1) {
    this.donorService.search(value, searchType)
      .pipe(takeUntil(this.takeUntilSubject))
      .subscribe((userProfiles) => {
        this.allProfiles = userProfiles;
        this.search(value);
    });
  }

  public search(searchValue: string) {
    if (!this.allProfiles?.usersProfile) {
      this.searchResult = [];
      return;
    }

    const profileInfo = this.allProfiles.usersProfile.map(data => ({
      "data": data,
      "searchString": data.email + "/" + data.name
    }));

    const filteredResult = profileInfo.filter((item) => 
      item.searchString.toLowerCase().includes(searchValue.toLowerCase())
    );

    this.searchResult = filteredResult;
  }

  public passOption(searchQuery: string | KeyboardEvent) {
    let searchString = '';
    if(searchQuery instanceof KeyboardEvent && searchQuery.target instanceof HTMLInputElement){
      searchString = searchQuery.target.value;
    } else{
      searchString = searchQuery as string;
    }

    const [email, name] = this.emailNameSpliter.getNameAndEmail(searchString)

    const selectedUser = this.allProfiles.usersProfile.find(user => 
      user.name === name && user.email === email
    );

    if (!selectedUser) {
      return;
    }

    this.donorData = selectedUser;

    this.form.patchValue({
      name: name,
      email: email
    }, { emitEvent: false });

    window['orgMain'].selectOfflineDonationOneDonor(selectedUser);
  }
}
